var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "create-event-modal" } },
    [
      _c(
        "a-modal",
        {
          attrs: {
            id: "event-modal",
            visible: true,
            cancelText: _vm.$t("calendar.cancel"),
            okText: _vm.$t("message.save"),
            centered: "",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-container" },
            [
              !!_vm.eventDetail.reservationId
                ? _c("ReservationEventModal", {
                    attrs: { eventDetail: _vm.eventDetail },
                    on: {
                      deleteEvent: _vm.onDeleted,
                      close: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  })
                : _c("CreateEventForm", {
                    attrs: {
                      eventSummary: _vm.eventSummary,
                      eventDetail: _vm.eventDetail,
                      selectedStartDate: _vm.selectedStartDate,
                      selectedEndDate: _vm.selectedEndDate,
                      calendarList: _vm.calendarList,
                      refVisitor: _vm.refVisitor,
                      footerVisible: _vm.footerVisible,
                    },
                    on: {
                      close: function ($event) {
                        return _vm.$emit("close")
                      },
                      deleteEvent: _vm.onDeleted,
                      editEvent: function ($event) {
                        return _vm.$emit("editEvent", $event)
                      },
                    },
                  }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }